<form (submit)="onSubmit($event)" class="marketplace-search-container" action="#">
  <fa-icon icon="search"></fa-icon>

  <input
    #searchInput
    class="marketplace-search-input form-control w-100"
    [(ngModel)]="query"
    autocomplete="off"
    enterkeyhint="search"
    name="marketplace-search"
    placeholder="{{ 'Search listings...' | translate }}"
    type="search"
  />
</form>
